import { UPDATE_ONSTREET_DELIVERY_MARKER_DATA } from "./onstreetDeliveryMarkerDataReducer"

export const updateOnstreetDeliveryMarkerData = (info) => ({
    type: UPDATE_ONSTREET_DELIVERY_MARKER_DATA,
    payload: info
})